import { useState } from 'react';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import SearchTab from './Tabs/SearchTab';
import FoldersTab from './Tabs/FoldersTab';

const SEARCH_TABS = {
  SEARCH: 'Search',
  FOLDERS: 'Folders',
};

const styles = {
  container: {
    p: '2px 8px',
    borderRadius: '8px',
    bgcolor: '#ecf1f4',
    '.MuiTabs-root': {
      alignItems: 'center',
      minHeight: '50px',
    },
    '.MuiTab-root': {
      fontWeight: 700,
      opacity: 0.7,
      mx: '4px',
      borderRadius: '4px',
      textTransform: 'none',
      height: '40px',
      minHeight: '40px',
      '&.Mui-selected': {
        opacity: 1,
        bgcolor: 'rgba(0, 117, 169, 0.2)',
        color: '#1D2433CC',
      },
    },
  },
};

const SearchContainer = () => {
  const [activeTab, setActiveTab] = useState(SEARCH_TABS.SEARCH);

  const handleChange = (_, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box
      position="relative"
      minHeight="30vh"
      border={2}
      borderColor="#E0E0E0"
      borderRadius="8px"
      p={1}
    >
      <TabContext value={activeTab}>
        <Box sx={styles.container}>
          <TabList indicatorColor="transparent" onChange={handleChange}>
            <Tab value={SEARCH_TABS.SEARCH} label={SEARCH_TABS.SEARCH} />
            <Tab value={SEARCH_TABS.FOLDERS} label={SEARCH_TABS.FOLDERS} />
          </TabList>
        </Box>
        <TabPanel sx={{ p: '15px' }} value={SEARCH_TABS.SEARCH}>
          <SearchTab />
        </TabPanel>
        <TabPanel sx={{ p: '15px' }} value={SEARCH_TABS.FOLDERS}>
          <FoldersTab />
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default SearchContainer;
